import { useEffect } from "react";
import PropTypes from "prop-types";
import config from "../../../config/index";
import { MOBILE_WIDTH, TABLET_WIDE_WIDTH } from "../../../config/constants";
import { componentCheckSize } from "../../../utils/helperServices";
import {
  error as AnalyticsError
} from "../../../services/analyticsUtag";
import styles from "./ErrorTooltip.module.scss";

const ErrorTooltip = ({
  errorMsg,
  buttonHandler,
  buttonLabel,
  type,
  hideDismissButton,
  className,
  textClass,
  dismissClass,
  showAnalytics,
  customStyle = {},
  setFixedTop = false,
}) => {
  const env = config.env;
  const winWidth = componentCheckSize();
  const isMobile = winWidth <= MOBILE_WIDTH;
  const isTablet = winWidth <= TABLET_WIDE_WIDTH;
  const specialClass =
    ["not_allow_place_order", "orders_service"].indexOf(type) !== -1;
  const isHideIcon = isMobile && !specialClass;
  const imagePrefix = config.envConfigs[env].imagePrefix;
  const imgUrl =
    type === "upgrade"
      ? `${imagePrefix}/assets/images/upgrade-info.svg`
      : type === "alert"
      ? `${imagePrefix}/assets/images/bell-icon.svg`
      : `${imagePrefix}/assets/images/warning-black.svg`;
  let imgSize = 25;

  switch (type) {
    case "upgrade":
    case "alert":
    case "warning":
      imgSize = 30;
      break;
    case "not_allow_place_order":
      imgSize = 17.6;
      break;
  }

  useEffect(() => {
    if (errorMsg && showAnalytics) {
      AnalyticsError(errorMsg);
    }

  }, []);

  customStyle = setFixedTop
    ? {
        ...customStyle,
        position: 'fixed',
        top: '0',
      }
    : customStyle;

  return (
    <div
      className={`${styles["error-card-block"]} ${styles[type]} ${className}`} style={customStyle}
    >
      <div className={`${styles["textContainer"]} ${textClass}`}>
        <div
          className={`d-flex ${
            specialClass && isTablet
              ? "align-items-flex-start"
              : "align-items-center"
          }`}
        >
          {!isHideIcon && (
            <img
              className={styles["error-icon"]}
              src={imgUrl}
              width={imgSize}
              height={imgSize}
            />
          )}
          <span className={styles["error-card-message"]}>
            {errorMsg ? errorMsg : ""}
          </span>
        </div>
        {!hideDismissButton && (
          <div className={`${styles["dismiss_button"]} ${dismissClass}`}>
            <button onClick={buttonHandler}>
              {buttonLabel ? buttonLabel : "Dismiss"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

ErrorTooltip.propTypes = {
  type: PropTypes.string,
  errorMsg: PropTypes.string,
  hideDismissButton: PropTypes.bool,
  buttonLabel: PropTypes.string,
  buttonHandler: PropTypes.func,
  className: PropTypes.any,
  showAnalytics: PropTypes.bool,
  customStyle: PropTypes.any,
  textClass: PropTypes.string,
  dismissClass: PropTypes.string,
};

ErrorTooltip.defaultProps = {
  type: "default",
  hideDismissButton: false,
  showAnalytics: true,
};

export default ErrorTooltip;
